module.exports = __webpack_public_path__ + "5825c64eecbd2a3ca034c16bc5d58654.jpg";